import { z } from "zod";
import { dateRangeSchema } from "../../utils";

const equipmentRentalItemSchema = z.object({
  equipmentId: z.string(),
  equipmentName: z.string(),
  quantity: z.coerce.number().min(0),
  dateRange: dateRangeSchema.optional(),
  price: z.coerce.number().nullable(),
});

export type EquipmentRentalItem = z.infer<typeof equipmentRentalItemSchema>;

export const RentEquipmentSchema = z.object({
  equipments: z.array(equipmentRentalItemSchema),
});

export type RentEquipmentForm = z.infer<typeof RentEquipmentSchema>;

export const createDefaultRentEquipmentValues = (
  equipments: Array<{ id: string; name: string }>,
): RentEquipmentForm => ({
  equipments: equipments.map((equipment) => ({
    equipmentId: equipment.id,
    equipmentName: equipment.name,
    quantity: 0,
    dateRange: undefined,
    price: 0,
  })),
});
